/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

/**
 * Created by andrea on 2017-06-27.
 */

export class Studio {

  constructor(public id: string,
              public name: string,
              public identifier: string = null,
              public city: string = null,
              public isIndependent: boolean = false) {

  }

  static fromEntryJson(json: any) {
    if (!json) {
      return null;
    }
    return Studio._fromEntrySnapshot(json);
  }

  static fromJsonArray(json: any) {
    let studios: Studio[] = [];

    let keys = Object.keys(json);
    studios = keys.map(key => Studio._fromSnapshot(key, json[key]));

    return studios;
  }

  private static _fromEntrySnapshot({identifier, key, name}) {
    return new Studio(key, name, identifier);
  }

  private static fromSnapshot(snapshot: any) {
    return Studio._fromSnapshot(snapshot.key, snapshot.val());
  }

  private static _fromSnapshot(key: string, {identifier, name, city, independent}) {
    return new Studio(key, name, identifier, city, independent);
  }

}



// WEBPACK FOOTER //
// ./src/models/Studio.ts